import { render, staticRenderFns } from "./u-popup.vue?vue&type=template&id=52d4ddd1&scoped=true&"
import script from "./u-popup.vue?vue&type=script&lang=js&"
export * from "./u-popup.vue?vue&type=script&lang=js&"
import style0 from "./u-popup.vue?vue&type=style&index=0&id=52d4ddd1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4ddd1",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-popup/u-popup.vue"
export default component.exports